/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeExpectedPaymentSettingPostRequestSchema } from './changeExpectedPaymentSettingPostRequestSchema.ts';
import { changeExpectedPaymentSettingPostResponseSchema } from './changeExpectedPaymentSettingPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postChangeExpectedPaymentSetting200Schema = z.lazy(() => changeExpectedPaymentSettingPostResponseSchema);

/**
 * @description 505 response
 */
export const postChangeExpectedPaymentSetting505Schema = z.any();

export const postChangeExpectedPaymentSettingMutationRequestSchema = z.lazy(
  () => changeExpectedPaymentSettingPostRequestSchema
);

export const postChangeExpectedPaymentSettingMutationResponseSchema = z.lazy(
  () => postChangeExpectedPaymentSetting200Schema
);
